import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { goBack } from 'react-router-redux';
import { PreviewOneFormProjectCard } from '../Project/PreviewOneFormProjectCard';
import { ProjectActionCreators } from '../../../actions';
import { ProjectType } from '../../../utils/enums';

class ProbeCardPreviewContainerBO extends Component {
	constructor(props) {
		super(props);
		this.onGoBack = this.onGoBack.bind(this);
	}

	componentDidMount() {
		let { id, clientId } = this.props.match.params;
		if (id) {
			this.props.getProject(id, clientId);
		}
	}

	onGoBack() {
		this.props.goBack();
	}

	render() {
		return (
			<PreviewOneFormProjectCard
				{...this.props.project}
				disabled={true}
				consultationTitle="Sonda"
				loggedUserId={this.props.loggedUserId}
				type={ProjectType.Probe}
				saveAnswers={(values) => this.props.saveAnswers(values)}
				onCancel={this.onGoBack}
				isProjectLoading={this.props.isProjectLoading}
				opinionExecuting={this.props.opinionExecuting}
				voteExecuting={this.props.voteExecuting}
				isPreview={true}
			/>
		);
	}
}

const mapStateToProps = (state, ownProps) => {
	return {
		isProjectLoading: state.project.isProjectLoading,
		opinionExecuting: state.project.opinionExecuting,
		voteExecuting: state.project.voteExecuting,
		project: state.project.project,
		loggedUserId: state.app.loggedUser.userId
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	return Object.assign({}, bindActionCreators(ProjectActionCreators, dispatch), {
		goBack: () => dispatch(goBack())
	});
};

export default connect(mapStateToProps, mapDispatchToProps)(ProbeCardPreviewContainerBO);
